<template>
  <div>
    <div class="flex justify-between mt-3 test-total">
      <div class="flex">
        <p>{{ $t("OrderPage[\"Lab Processing fee:\"]") }}</p>
        <span 
          class="material-icons-outlined info-icon" 
          @click="centerDialogVisible = true">info
        </span>
        <labProcessingFeeDialog 
          :centerDialogVisible="centerDialogVisible"
          @close="centerDialogVisible = false"
        />
      </div>
      <p>{{ currency.symbol + nonReturnPatientProcessingFeeCalcd.toFixed(2) }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import labProcessingFeeDialog from "../../../order-summary/SummaryAccessories/estimate-total/labProcessingFeeDialog.vue"
export default {
  components: {
    labProcessingFeeDialog,
  },
  props: {
    nonReturnPatientProcessingFeeCalcd: {
      type: Number,
      default: 0     
    },
  },
  data() {
    return {
      centerDialogVisible: false
    }
  },
  computed: {
    ...mapState(["currency"])
  }
}
</script>

<style scoped>
.info-icon {
  margin-left: 3.5px;
  margin-top: 1px;
  font-size: 15px;
  cursor: default;
}

.test-total {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4576px;
  color: #000000;
  height: 16px;
}
</style>
